import { render, staticRenderFns } from "./ftReportDetail.vue?vue&type=template&id=49af145f&scoped=true"
import script from "./ftReportDetail.vue?vue&type=script&lang=js"
export * from "./ftReportDetail.vue?vue&type=script&lang=js"
import style0 from "./ftReportDetail.vue?vue&type=style&index=0&id=49af145f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49af145f",
  null
  
)

export default component.exports